export const PLAN_PRICES = {
    '1-week-plan': 799,
    '1-month-plan': 1599,
    '3-months-plan': 3199,
};

export function getPlanPrice(planId) {
    return PLAN_PRICES[planId] || 0;
}
